package ru.notamedia.qah.screens.qa_json_validator

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeContentPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import kotlinx.serialization.json.Json
import org.jetbrains.compose.resources.painterResource
import qualityassurancehelper.composeapp.generated.resources.Res
import qualityassurancehelper.composeapp.generated.resources.json_format
import ru.notamedia.qah.NavController
import ru.notamedia.qah.components.HeaderScreen
import ru.notamedia.qah.managers.JsonValidationReporter
import ru.notamedia.qah.managers.PrettyFormatter
import ru.notamedia.qah.validators.JsonValidator
import ru.notamedia.qah.web.LocalStorage

@Composable
fun QAJsonValidatorScreen(navController: NavController) {
    Column(
        modifier = Modifier
            .background(Color.White)
            .safeContentPadding()
            .verticalScroll(rememberScrollState())
            .fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {

        HeaderScreen(
            navController = navController,
            title = "Валидатор структуры JSON",
        )

        var expectedInput by remember { mutableStateOf("") }
        var isErrorExpected by remember { mutableStateOf(false) }

        var actualInput by remember { mutableStateOf("") }
        var isErrorActual by remember { mutableStateOf(false) }

        var report by remember { mutableStateOf<String?>(null) }

        LaunchedEffect(Unit) {
            expectedInput = LocalStorage.get("expectedInput")
            actualInput = LocalStorage.get("actualInput")
        }

        LaunchedEffect(expectedInput) {
            isErrorExpected = if (expectedInput.isEmpty()) {
                false
            } else {
                PrettyFormatter.tryFormatJsonPretty(expectedInput) == null
            }

            LocalStorage.save("expectedInput", expectedInput)
        }

        LaunchedEffect(actualInput) {
            isErrorActual = if (actualInput.isEmpty()) {
                false
            } else {
                PrettyFormatter.tryFormatJsonPretty(actualInput) == null
            }
            LocalStorage.save("actualInput", actualInput)
        }

        Row(
            modifier = Modifier
                .padding(16.dp)
                .fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            Column(
                modifier = Modifier.weight(1f)
            ) {
                OutlinedTextField(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(500.dp),
                    value = expectedInput,
                    onValueChange = { expectedInput = it },
                    singleLine = false,
                    placeholder = { Text("Ожидаемый JSON") },
                    textStyle = MaterialTheme.typography.bodySmall,
                )

                if (isErrorExpected) {
                    Text(
                        text = "Невалидный JSON",
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.Red,
                    )
                }
            }

            Column(
                modifier = Modifier.width(32.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Box(
                    modifier = Modifier.clickable(
                        onClick = {
                            PrettyFormatter.tryFormatJsonPretty(expectedInput)
                                ?.also { expectedInput = it }

                            PrettyFormatter.tryFormatJsonPretty(actualInput)
                                ?.also { actualInput = it }
                        },
                    )
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.json_format),
                        contentDescription = "Format JSON",
                    )
                }
            }

            Column(
                modifier = Modifier.weight(1f)
            ) {

                OutlinedTextField(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(500.dp),
                    value = actualInput,
                    onValueChange = { actualInput = it },
                    singleLine = false,
                    placeholder = { Text("Фактический JSON") },
                    textStyle = MaterialTheme.typography.bodySmall,
                )

                if (isErrorActual) {
                    Text(
                        text = "Невалидный JSON",
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.Red,
                    )
                }
            }
        }

        Button(
            onClick = {
                report = try {
                    val expected = Json.parseToJsonElement(expectedInput)
                    val actual = Json.parseToJsonElement(actualInput)
                    val issues = JsonValidator.validate(expected, actual)
                    JsonValidationReporter.generateReport(issues)
                } catch (e: Throwable) {
                    "[Ошибка] Не удалось разобрать JSON"
                }
            },
            modifier = Modifier.align(Alignment.CenterHorizontally)
        ) {
            Text("Проверить")
        }

        report?.let {
            HorizontalDivider(
                modifier = Modifier.padding(32.dp),
            )
            Text(
                text = "Результат:",
                style = MaterialTheme.typography.titleMedium,
            )
            SelectionContainer {
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(16.dp),
                    text = it,
                    style = MaterialTheme.typography.bodyMedium,
                    textAlign = TextAlign.Center,
                )
            }
        }
    }
}
